export const setCookie = (name, value, expiration, path = '/') => {
    const d = new Date();
    d.setTime(d.getTime() + expiration);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=${path}`;
};
export const getCookie = (name) => {
    const dCookie = decodeURIComponent(document.cookie);
    const cookies = dCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cp = cookies[i].trim().split('=');
        if (cp[0] === name)
            return cp[1];
    }
    return null;
};
export const isObject = (item) => !!item && typeof item === 'object' && !Array.isArray(item);
export const mergeDeep = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    let result = Object.assign({}, target);
    sources.forEach(source => {
        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(target[key])) {
                    if (!target[key]) {
                        result = Object.assign(result, target, { [key]: {} });
                    }
                    result[key] = mergeDeep(target[key], source[key]);
                }
                else {
                    result = Object.assign(result, target, { [key]: source[key] });
                }
            }
        }
    });
    return result;
};
